/* eslint-disable camelcase */
export const hasDocument = () => typeof document !== 'undefined';

export const hasWindow = () => typeof window !== 'undefined';

export const hasCallToAction = ({ call_to_action_text, call_to_action_link }) =>
  call_to_action_text?.text && call_to_action_link?.url;

export const getLanguageCode = lang => lang?.split('-')[0] || '';

export * from './useSiteMetadata';
export * from './useLocalizedNews';
export * from './useLocalizedEvents';
export * from './useLocalizedLogoRibbon';
export * from './useLocalizedSiteBottom';
export * from './useLocalizedFaqs';
export * from './image';
